// eslint-disable-next-line import/prefer-default-export
export enum PlanChangeStatuses {
    IN_PROGRESS = 'Em andamento',
    CREDIT_REJECTION = 'Reprovação na análise de crédito',
    SUCCESS = 'Sucesso',
  }
